export default __webpack_public_path__ + "static/peer-2ee93322981f1dca26ddae142d2337f2.png";